import React from "react";
import { Link } from "react-router-dom";
import { pageURLs } from "@/constants";
import { LOGIN, SIGNUP } from "@/constants/onBoarding";
import "./GuestHeaderActions.scss";

const GuestHeaderActions = ({ handleAgentOnboardingModal }) => (
  <div className="guest-header-actions">
    <Link className="guest-header-actions__link" to={pageURLs.agentDirectory}>
      Agents
    </Link>
    <button
      type="button"
      className="guest-header-actions__link"
      onClick={() => handleAgentOnboardingModal?.({ showPopup: true, userAction: LOGIN })}
    >
      Sign in
    </button>
    <button
      type="button"
      className="guest-header-actions__start"
      onClick={() => handleAgentOnboardingModal?.({ showPopup: true, userAction: SIGNUP })}
    >
      Get started
    </button>
  </div>
);

export default GuestHeaderActions;
